import { render, staticRenderFns } from "./icon_lots_plans.vue?vue&type=template&id=4ffd916d&scoped=true&"
import script from "./icon_lots_plans.vue?vue&type=script&lang=js&"
export * from "./icon_lots_plans.vue?vue&type=script&lang=js&"
import style0 from "./icon_lots_plans.vue?vue&type=style&index=0&id=4ffd916d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd916d",
  null
  
)

export default component.exports